module.exports = __webpack_public_path__ + "img/DNADamage-GBM_10X_WTA.c0660017.png";